import React, { useState, useEffect } from 'react'
import style from './styles.module.css'
import $mathjaxData from './mathJax.json'
import pi from '../../static/img/pi.png'
import omega from '../../static/img/omega.png'
import englishIcon from '../../static/img/englishIcon.png'
import imageIcon from '../../static/img/imageIcon.png'
import { Editor } from '@tinymce/tinymce-react';
import callApi from '../../util/callApi'
import { NotificationManager } from "react-notifications";
import _ from 'lodash';
import { CommentImages } from './CommentImages'
import mathJaxUtil from '../../util/mathjaxUtil'
import { useSocket } from '../../useSocket';
import QRCode from "react-qr-code";
import { WEB_DOMAIN } from '../../config/config';

function changeShowImage(arrayImages) {
  var newImage = [];
  arrayImages.forEach(image => {
    newImage.push({ src: image })
  });
  return newImage;
}

export const BoxFormula = (props) => {
  const [code, setCode] = useState("");
  const [arrayCode, setArrayCode] = useState();
  const [showTab, setShowTab] = useState(false);
  const [showQRcode, setShowQRcode] = useState(false);
  const [disableSendComment, setDisableSendComment] = useState(false);
  const [showData, setShowData] = React.useState([]);
  // Hien thi hin anh
  const { comment_id } = props;
  let images = changeShowImage(props.images || [])

  // xử lý tabs latex
  const handleToggleMenu = (index) => {
    if (arrayCode == index) {
      setShowTab(!showTab);
    } else {
      setShowTab(true);
      setShowQRcode(false);
    }
    if (index == 0) {
      setArrayCode(0);
    } else if (index == 1) {
      setArrayCode(1)
    } else if (index == 2) {
      setArrayCode(2)
    }
  }

  const handleSetCode = (value) => {
    setCode(code + value);
    // props.getCode(code)
  }

  const socket = useSocket(props.user_id);

  useEffect(() => {
    if (!socket) return;
    const handleUploaded = (payload) => {
      const qid = comment_id ? `c_${comment_id}` : 'c_0';
      if (payload.qid === qid && payload.url) {
        setShowData((prev) => {
          return [...prev, { src: payload.url }].slice(-2);
        });
      }
    };

    socket.on("uploaded", handleUploaded);

    return () => {
      socket.off("uploaded");
    };
  }, [socket, comment_id]);

  useEffect(() => {
    mathJaxUtil.renderMathjax(document.getElementById('preview-mathjax'));
  }, [code]);

  const handleEditorChange = (html_content, editor) => {
    setCode(html_content);
  }

  const handleSubmitBox = async () => {
    if (disableSendComment) {
      NotificationManager.error('Ảnh đang được tải. Vui lòng chờ!', '', 1300);
      return false;
    }
    if (!code || (code && code == '')) {
      NotificationManager.error('Bạn cần điền nội dung câu hỏi', '', 1300);
      return false;
    }

    const src_images = _.map(showData, 'src');
    const response = await callApi('v1/user_comment/insert', 'post', { item_id: props.item_id, item_type: props.item_type, content: code, root_comment_id: comment_id, images: src_images, item_action: props.item_action ? props.item_action : null });
    if (response.code == 200) {
      props.pushCmt(response.data);
      setCode('');
      setShowData([]);
      NotificationManager.success('Success!', '', 1300);
    } else {
      if (response.code == 500) {
        NotificationManager.error(response.message ? response.message : 'Có lỗi xảy ra, hãy liên hệ lại Admin Tuyensinh247!', '', 2300);
      } 
      // else {
      //   NotificationManager.error(response.message ? response.message : 'Bạn cần đăng nhập để đặt câu hỏi', '', 2300);
      // }
    }
  }

  const onFileChange = () => {
    const elm_id = comment_id ? `upload_imgs_for_comment_${comment_id}` : 'upload_imgs_for_comment';
    const fileSelect = document.getElementById(elm_id);
    const files = fileSelect.files;
    if ((showData.length + files.length) > 2) {
      NotificationManager.error('Không được sử dụng quá 2 ảnh trong 1 bình luận!', '', 1300);
      return;
    }
   
    let x = showData.length;
    let totalItem = files.length;
    const old_showData = _.clone(showData);
    let tmpShowData = showData;
    for (let i = x; i < (totalItem + x); i++) {
      tmpShowData.push('/public/loading-pages.gif');
    }
    setShowData(tmpShowData);
    _.forEach(files, async function (file, key) {
      const data = new FormData();
      data.append('file', file, file.name);
      setDisableSendComment(true)
      uploadImage(data, 'comment', x).then((res) => {
        if (res.code == 200) {
          setShowData([...old_showData, ...[{ src: res.data.url }]]);
        } else {
          NotificationManager.error('Xảy ra lỗi khi upload ảnh!', '', 1300);
        }
        setDisableSendComment(false)
      })
      x++;
     
      return true
    });
  }

  const uploadImage = (data, type, index = 0) => {
    return new Promise((resolve, reject) => {
      callApi('v1/media/upload', 'post', data).then(res => {
        return resolve(res)
      })
        .catch(err => {
          return reject(err)
        })
    })
  }

  const handleDisableCopy = (e) => {
    e.preventDefault()
    return false

  }

  // chỉnh lại nền 
  var bg = props.bg ? props.bg : { card: '', bgTXT: '' };
  // chỉnh lại nền 
  const plugin_pc = ['advlist autolink lists link image charmap print preview anchor', 'searchreplace visualblocks code fullscreen', 'insertdatetime media table paste code help']
  // const toolbar = 'bold italic underline | \ alignleft aligncenter alignright alignjustify autoresize';
  const toolbar = '';
  const valid_elements = 'p,u,strike,strong/b,-ul[type|compact],-li,-ol[type|compact],-span[*],-sub,-sup,em/i,a[*],img[*],br';
  let plugin_mobile = ['advlist autolink lists image charmap print preview anchor', 'searchreplace visualblocks code fullscreen',
    'insertdatetime media table paste code help'
  ];

  const removeImage = (src) => {
    const x = showData.filter(elm => elm.src != src);
    setShowData(x);
  }
  const qrLink = `${WEB_DOMAIN}/eExamOnline/mobileUpload/rid/${props.user_id}/qid/c_${comment_id ? comment_id : '0'}`;
  const toggleShowQRcode = () => {
    setShowQRcode((oShow) => !oShow);
    setShowTab(false);
  }

  return (
    <div className={`${style.ts247MathFormula} ${style.box282}`} >
      <div className="cardBg" style={{ background: bg.card }}>
        {/* <textarea style={{background:bg.bgTXT}} className={style.inputMathJax} placeholder="Gửi nội dung bài tập mà bạn muốn hỏi tại đây" value={code} onChange={(e) => handleChange(e)}></textarea> */}
        <Editor 
          tinymceScriptSrc='/comment/static/tinymce/tinymce.min.js'
          value={code} cloudChannel='5-stable'
          init={{
            height: 130, branding: false, menubar: false, statusbar: false,
            mobile: {
              theme: 'silver',
              plugins: plugin_mobile,
            },
            valid_elements: valid_elements,
            plugins: plugin_pc,
            body_class: "commentInputClass",
            forced_root_block: '',
            placeholder: "Gửi câu hỏi thắc mắc tại đây để được Thầy/Cô giáo hỗ trợ giải đáp. Lưu ý: Mỗi lần chỉ hỏi về 1 bài tập, sử dụng từ ngữ phù hợp và không gửi hình ảnh chứa logo, thương hiệu của các trang học khác.",
            auto_focus: "elm1",
            force_p_newlines: true,
            relative_urls: false,
            remove_script_host: false,
            convert_urls: true,
            toolbar: toolbar,
            content_style: "p { margin-block-end: 6px !important; margin-block-start: 6px !important;line-height:22px}@media (max-width: 350px) {.mce-content-body[data-mce-placeholder]{font-size:13px !important;}}"
          }}
          onEditorChange={handleEditorChange}
        />
        <div className={style.toolFormula}>
          <div className={style.leftContent}>
            <a onClick={() => handleToggleMenu(0)} className={showTab && arrayCode == 0 ? `${style.btnToggleFomula} ${style.active}` : `${style.btnToggleFomula}`}><img src={pi} /></a>
            <a onClick={() => handleToggleMenu(1)} className={showTab && arrayCode == 1 ? `${style.btnToggleFomula} ${style.active}` : `${style.btnToggleFomula}`}><img src={omega} /></a>
            <a onClick={() => handleToggleMenu(2)} className={showTab && arrayCode == 2 ? `${style.btnToggleFomula} ${style.active}` : `${style.btnToggleFomula}`}><img src={englishIcon} /></a>
            <label
              htmlFor={comment_id ? `upload_imgs_for_comment_${comment_id}` : 'upload_imgs_for_comment'}
              className={showTab && arrayCode == 2 ? `${style.btnToggleFomula} ${style.active}` : `${style.btnToggleFomula}`}
              className={style.btnToggleFomula}><img className={style.imageIcon} src={imageIcon} />&nbsp;({showData.length}/2)&nbsp; <span className={style.hiddenMobi}>Gửi ảnh từ máy tính</span>
              <input style={{ display: 'none' }} type="file" id={comment_id ? `upload_imgs_for_comment_${comment_id}` : 'upload_imgs_for_comment'} onChange={onFileChange} />
            </label>
            <a onClick={() => toggleShowQRcode()} className={`${style.btnToggleFomula} ${style.hiddenMobi}`}>Gửi ảnh từ điện thoại</a>
          </div>
          <a className={style.frameBtn} onClick={handleSubmitBox} disabled={disableSendComment}> Gửi </a>
        </div>
        {
          showTab ?
            <><ul className={style.listMathJax} style={{ background: bg.bgTXT }}>
              {
                $mathjaxData[arrayCode].items.map((item, index) => {
                  return (
                    <li key={index} onClick={() => handleSetCode(item.value)} style={{ background: bg.card }}>
                      <span dangerouslySetInnerHTML={{ __html: item.image == undefined ? item.value : item.image }} ></span>
                    </li>
                  )
                })
              }
            </ul>
              <div className="preview-mathjax" id="preview-mathjax">
                <div disabled={true} className={style.preview} dangerouslySetInnerHTML={{ __html: code != '' ? code : 'Xem trước' }} onCut={(e)=>{ return handleDisableCopy(e) }} onCopy={(e)=>{return handleDisableCopy(e) }}></div>
              </div>
            </> : ''
        }
        {!showTab && showQRcode && (
          <div style={{padding: 10, textAlign: 'center'}}>
            <p>Up ảnh từ điện thoại bằng cách quét mã QR sau:</p>
            <QRCode size={180} value={qrLink} />
          </div>
        )}
        {
          showData.length > 0 ? <CommentImages removeImage={removeImage} showData={showData} /> : ''
        }
      </div>
    </div>
  );
}